import { createRouter, createWebHistory } from 'vue-router';

import store from '../store';

const routes = [
    // Dashboard
    {
        path: '/',
        name: 'Home',
        component: () => import(/* webpackChunkName: "dashboard" */ '../views/cdi/dashboard.vue'),
    },

    // Contratos
    {
        path: '/contratos',
        name: 'contratos',
        component: () => import(/* webpackChunkName: "contratos-lista" */ '../views/cdi/contratos/lista.vue'),
    },
    {
        path: '/contratos/nuevo',
        name: 'contratos-nuevo',
        component: () => import(/* webpackChunkName: "contratos-formulario" */ '../views/cdi/contratos/formulario.vue'),
    },
    {
        path: '/contratos/:id/editar',
        name: 'contratos-editar',
        component: () => import(/* webpackChunkName: "contratos-formulario" */ '../views/cdi/contratos/formulario.vue'),
        props: true,
    },
    {
        path: '/contratos/:id',
        name: 'contratos-detalle',
        component: () => import(/* webpackChunkName: "contratos-detalle" */ '../views/cdi/contratos/detalle.vue'),
        props: true,
    },

    // Proveedores
    {
        path: '/proveedores',
        name: 'proveedores',
        component: () => import(/* webpackChunkName: "proveedores-lista" */ '../views/cdi/proveedores/lista.vue'),
    },
    {
        path: '/proveedores/nuevo',
        name: 'proveedores-nuevo',
        component: () => import(/* webpackChunkName: "proveedores-formulario" */ '../views/cdi/proveedores/formulario.vue'),
    },
    {
        path: '/proveedores/:id/editar',
        name: 'proveedores-editar',
        component: () => import(/* webpackChunkName: "proveedores-formulario" */ '../views/cdi/proveedores/formulario.vue'),
        props: true,
    },
    {
        path: '/proveedores/:id',
        name: 'proveedores-detalle',
        component: () => import(/* webpackChunkName: "proveedores-detalle" */ '../views/cdi/proveedores/detalle.vue'),
        props: true,
    },

    // Finanzas
    {
        path: '/finanzas/facturas',
        name: 'finanzas-facturas',
        component: () => import(/* webpackChunkName: "finanzas-facturas" */ '../views/cdi/finanzas/facturas.vue'),
    },

    // Alertas
    {
        path: '/alertas',
        name: 'alertas',
        component: () => import(/* webpackChunkName: "alertas" */ '../views/cdi/alertas/lista.vue'),
    },

    // IA
    {
        path: '/ia/analizar',
        name: 'ia-analizar',
        component: () => import(/* webpackChunkName: "ia-analizar" */ '../views/cdi/ia/analizar.vue'),
        meta: { requiereEscritura: true },
    },

    // Administración (solo Administrador)
    {
        path: '/administracion/usuarios',
        name: 'administracion-usuarios',
        component: () => import(/* webpackChunkName: "administracion-usuarios" */ '../views/cdi/administracion/usuarios.vue'),
        meta: { requiereAdmin: true },
    },
    {
        path: '/administracion/departamentos',
        name: 'administracion-departamentos',
        component: () => import(/* webpackChunkName: "administracion-departamentos" */ '../views/cdi/administracion/departamentos.vue'),
        meta: { requiereAdmin: true },
    },
    {
        path: '/administracion/etiquetas',
        name: 'administracion-etiquetas',
        component: () => import(/* webpackChunkName: "administracion-etiquetas" */ '../views/cdi/administracion/etiquetas.vue'),
        meta: { requiereAdmin: true },
    },

    // Auth
    {
        path: '/auth/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "auth-login" */ '../views/auth/login.vue'),
        meta: { layout: 'auth' },
    },

    // Perfil de usuario
    {
        path: '/users/profile',
        name: 'profile',
        component: () => import(/* webpackChunkName: "users-profile" */ '../views/users/profile.vue'),
    },
    {
        path: '/users/cambiar-password',
        name: 'users-cambiar-password',
        component: () => import(/* webpackChunkName: "users-cambiar-password" */ '../views/users/cambiar-password.vue'),
    },

    // 404
    {
        path: '/pages/error404',
        name: 'error404',
        component: () => import(/* webpackChunkName: "pages-error404" */ '../views/pages/error404.vue'),
        meta: { layout: 'auth' },
    },
    {
        path: '/:pathMatch(.*)*',
        redirect: { name: 'error404' },
    },
];

const router = new createRouter({
    history: createWebHistory(),
    linkExactActiveClass: 'active',
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { left: 0, top: 0 };
        }
    },
});

router.beforeEach((to, from, next) => {
    const esRutaAuth = !!(to.meta && to.meta.layout === 'auth');
    store.commit('setLayout', esRutaAuth ? 'auth' : 'app');

    const autenticado = store.state.auth.isAuthenticated;

    if (!esRutaAuth && !autenticado) {
        // Ruta protegida sin sesión activa -> a login.
        next({ name: 'login' });
    } else if (to.name === 'login' && autenticado) {
        // Ya con sesión: no tiene sentido volver a mostrar el login.
        next({ path: '/' });
    } else if (to.meta && to.meta.requiereAdmin && !store.getters['auth/isAdmin']) {
        // Sección de Administración: solo el rol Administrador puede entrar.
        next({ path: '/' });
    } else if (to.meta && to.meta.requiereEscritura && !(store.getters['auth/isAdmin'] || store.getters['auth/isGestor'])) {
        // Acciones de escritura (ej. IA): Auditor/Lector no puede crear nada.
        next({ path: '/' });
    } else {
        next(true);
    }
});

export default router;
